import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
// The real Finkit/noa theme stylesheets are linked in index.html; this only
// adds a few SPA-specific tweaks on top, using the theme's own CSS variables.
import '@/styles/app.css';
import { AppProviders } from '@/app/providers/AppProviders';
import { applyThemeMode, resolveInitialMode } from '@/app/layouts/ThemeSwitcher';
import { tenantStore } from '@/tenant/tenantStore';

// Apply the saved theme (light / dark / dark-blue) before first paint.
applyThemeMode(resolveInitialMode());
// Keep the ABP __tenant cookie in sync with the SPA's tenant (host = no cookie).
tenantStore.syncCookie();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
